import { render, staticRenderFns } from "./OnlineStoreDetail.vue?vue&type=template&id=e8f82c20&scoped=true&"
import script from "./OnlineStoreDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineStoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./OnlineStoreDetail.vue?vue&type=style&index=0&id=e8f82c20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f82c20",
  null
  
)

export default component.exports